// extracted by mini-css-extract-plugin
export default {"heroSection":"HeroSectionStyles_heroSection__etfar","net":"HeroSectionStyles_net__8rSrm","content":"HeroSectionStyles_content__SMitg"};